import React from 'react';
import { Typography } from 'antd';
import Barcode from 'react-barcode';
import aurikshaLogo from '../../../assets/auriksha_logo.png';
import companyInfo from '../../../jsons/companyInfo.json';

const { Text } = Typography;

const formatDate = (d) =>
  d ? new Date(d).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' }) : '—';

/**
 * The masthead of the printed bill: who issued it, to what document number, on
 * what date. Kept separate from the CreateBill form header — a document header
 * needs a fixed, print-stable layout, not a form's.
 */
const BillInvoiceHeader = ({ billId, billDate, branchName, title = 'PURCHASE INVOICE' }) => {
  const metaRows = [
    ['Invoice No.', billId || '—'],
    ['Invoice Date', formatDate(billDate)],
    branchName ? ['Branch', branchName] : null,
    companyInfo.gstNumber ? ['GSTIN', companyInfo.gstNumber] : null,
  ].filter(Boolean);

  return (
    <div className="bill-masthead">
      {/* ── Issuer ── */}
      <div className="bill-masthead__issuer">
        <img src={aurikshaLogo} alt="Auriksha" className="bill-masthead__logo" />
        <div className="bill-masthead__name">{companyInfo.name}</div>
        <div className="bill-masthead__lines">
          <div>{companyInfo.cin}</div>
          <div>{companyInfo.addressLine1} {companyInfo.addressLine2}</div>
          <div>{companyInfo.addressLine3}</div>
          <div>
            {companyInfo.phone}
            {companyInfo.email ? ` · ${companyInfo.email}` : ''}
          </div>
        </div>
      </div>

      {/* ── Document identity ── */}
      <div className="bill-masthead__doc">
        <div className="bill-masthead__title">{title}</div>

        <table className="bill-masthead__meta">
          <tbody>
            {metaRows.map(([label, value]) => (
              <tr key={label}>
                <td className="bill-masthead__meta-label">{label}</td>
                <td className="bill-masthead__meta-value">{value}</td>
              </tr>
            ))}
          </tbody>
        </table>

        {billId ? (
          <div className="bill-masthead__barcode">
            <Barcode
              value={String(billId)}
              width={1.1}
              height={34}
              fontSize={10}
              margin={0}
              displayValue
            />
          </div>
        ) : (
          <Text type="secondary">No bill number</Text>
        )}
      </div>
    </div>
  );
};

export default BillInvoiceHeader;
